import { render, staticRenderFns } from "./feedbackDrawer.vue?vue&type=template&id=b748e954&scoped=true&"
import script from "./feedbackDrawer.vue?vue&type=script&lang=js&"
export * from "./feedbackDrawer.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDrawer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./feedbackDrawer.vue?vue&type=style&index=1&id=b748e954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b748e954",
  null
  
)

export default component.exports